import { createSelector } from 'reselect'
import { List, Map } from 'immutable'

export const getProtracks = state => state.get('persist').protracks

export const getLevels = createSelector(getProtracks, protracks => protracks.get('levels'))

export const getLevelsAll = createSelector(getLevels, levels => levels.get('all'))

export const getLevelsIds = createSelector(getLevels, levels => levels.get('ids'))

export const getLevelsView = createSelector(getLevels, levels => levels.get('view'))

export const getLevelsLoaded = createSelector(getLevels, levels => levels.get('loaded'))

export const getLevelsViewPresenter = createSelector(getLevelsAll, getLevelsView, (all, id) => {
  return id ? all.get(id.toString()) || null : null
})

export const isViewLevelPublished = createSelector(getLevelsViewPresenter, presenter => {
  if (!presenter) {
    return false
  }
  return presenter.get('active')
})

export const isViewLevelHasActivities = createSelector(getLevelsViewPresenter, presenter => {
  if (!presenter) {
    return false
  }
  return !!presenter.get('activitiesTotal')
})

export const getViewLevelHasActiveUsers = createSelector(getLevelsViewPresenter, presenter => {
  if (!presenter) {
    return false
  }
  if (presenter.get('isLibrary')) {
    return presenter.get('active')
  }
  return !!presenter.get('activeUsers')
})

export const getLevelsViewPresenterOrder = createSelector(
  getLevelsViewPresenter,
  presenter => (presenter ? presenter.get('order') : null)
)

export const getLevelsBeforeCreateOrder = createSelector(getLevels, levels => levels.get('beforeCreateOrder') + 1)

export const getLevelsList = createSelector(getLevelsAll, getLevelsIds, (all, ids) =>
  List(ids.map(id => all.get(id.toString())))
)

export const getLevelsListOrdered = createSelector(getLevelsList, list => list.sort((a, b) => a.order - b.order))

export const getAllPublishedLevelsList = createSelector(getLevelsListOrdered, levels =>
  levels.filter(level => level.get('active'))
)

export const getLastPublishedLevelId = createSelector(
  getAllPublishedLevelsList,
  levels => levels && levels.get && levels.get(-1) && levels.get(-1).get('id')
)

export const getLevelsListContainRates = createSelector(getLevelsListOrdered, list =>
  list.filter(level => level.get('ratesCount') !== 0)
)

export const getLevelsListForRequest = createSelector(getLevelsListOrdered, list => {
  let index = 1
  return list.reduce((acc, level) => {
    if (!level.deleting) {
      acc.push({
        id: level.id,
        order: index++,
      })
    }
    return acc
  }, [])
})

export const getViewLevel = createSelector([getLevelsAll, getLevelsView], (levels, id) => levels.get(id) || Map())

export const isViewLevelIsLibrary = createSelector(getViewLevel, level => level.get('isLibrary'))
